
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import '../../../node_modules/core-js/modules/es.array.concat.js';
import '../../../node_modules/core-js/modules/es.array.slice.js';
import '../../../node_modules/core-js/modules/es.parse-int.js';
import Color from '../../../node_modules/color/index.js';

var THEME_COLOURS = {
  primary: "#1B68B3",
  secondary: "#9EA5A9",
  green: "#3CB744",
  orange: "#FF9C28",
  red: "#D12525",
  black: "#232323",
  white: "#FFFFFF",
  blue: "#1B68B3"
};
var palletGenerator = function palletGenerator(base) {
  return {
    base: base,
    lightest: Color(base).lighten(0.7).hex(),
    lighter: Color(base).lighten(0.5).hex(),
    light: Color(base).lighten(0.2).hex(),
    dark: Color(base).darken(0.2).hex(),
    darker: Color(base).darken(0.4).hex(),
    darkest: Color(base).darken(0.6).hex()
  };
};
var colors = {
  primary: palletGenerator(THEME_COLOURS.primary),
  secondary: palletGenerator(THEME_COLOURS.secondary),
  green: palletGenerator(THEME_COLOURS.green),
  orange: palletGenerator(THEME_COLOURS.orange),
  red: palletGenerator(THEME_COLOURS.red),
  black: THEME_COLOURS.black,
  white: THEME_COLOURS.white,
  blue: THEME_COLOURS.blue
};
var hexToRGBA = function hexToRGBA(hex, alpha) {
  var red = parseInt(hex.slice(1, 3), 16);
  var green = parseInt(hex.slice(3, 5), 16);
  var blue = parseInt(hex.slice(5, 7), 16);
  return "rgba(".concat(red, ", ").concat(green, ", ").concat(blue, ", ").concat(alpha, ")");
};

export { THEME_COLOURS, colors, hexToRGBA, palletGenerator };
//# sourceMappingURL=colors.js.map
